module.exports = __webpack_public_path__ + "static/media/loan-id-highlight.d765928c.svg";